import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { User } from '../../../models/identity/user.model';

@Component({
    selector: 'app-mobile-user-list',
    templateUrl: './mobile-user-list.component.html',
    styleUrls: ['./mobile-user-list.component.scss'],
})
export class MobileUserListComponent {
    @Input() users: User[] = [];
    @Input() activeUserId: string = null;
    @Input() isLoading = false;
    @Input() searchText = '';
    @Input() showList = false;

    @Output() userSelected = new EventEmitter<string>();
    @Output() searchTextChanged = new EventEmitter<string>();
    @Output() scrolled = new EventEmitter<void>();
    @Output() closeModal = new EventEmitter<void>(); // Nouvel événement pour la fermeture

    constructor(public translate: TranslateService) {}

    onUserSelected(userId: string): void {
        this.userSelected.emit(userId);
    }

    onSearchTextChanged(text: string): void {
        this.searchTextChanged.emit(text);
    }

    onScroll(): void {
        this.scrolled.emit();
    }

    onClose(): void {
        this.closeModal.emit();
    }
}
